import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProductImage from './ProductImage';
import { genImageAlt } from '../../helpers';

const handleSmallImage = e => {
  if (e.target.height < 200) {
    const newStyles = `
    `;
    e.target.setAttribute('style', newStyles);
  }
};

class ProductImageCardInner extends Component {
  constructor(props) {
    super(props);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.state = { src: props.images[0] };
  }

  handleMouseOver() {
    const { images } = this.props;
    if (images && images[1]) {
      this.setState({ src: images[1] });
    }
  }

  handleMouseOut() {
    const { images } = this.props;
    if (images && images.length > 0) {
      this.setState({ src: images[0] });
    }
  }

  render() {
    const { cart, padTop, s3BasePath, width, height, product, placeholderWidth, placeholderHeight } = this.props;
    return (
      <ProductImage
        alt={product ? genImageAlt(product.model, product.brand, product.color) : null}
        data-cy="image-product"
        src={this.state.src}
        onError={e => (e.target.src = `${s3BasePath}mkt/icon/no_image.png`)}
        onLoad={e => (cart ? undefined : handleSmallImage(e))}
        padTop={padTop}
        onMouseOver={e => this.handleMouseOver(e)}
        onMouseOut={e => this.handleMouseOut(e)}
        width={width}
        height={height}
        minWidth={placeholderWidth}
        minHeight={placeholderHeight}
      />
    );
  }
}

ProductImageCardInner.propTypes = {
  cart: PropTypes.bool,
  images: PropTypes.array.isRequired,
  padTop: PropTypes.string,
  s3BasePath: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  product: PropTypes.object,
  placeholderWidth: PropTypes.string,
  placeholderHeight: PropTypes.string,
};

export default ProductImageCardInner;
